/* unplugin-vue-components disabled */import script from "./Zccx.vue?vue&type=script&lang=ts&setup=true"
export * from "./Zccx.vue?vue&type=script&lang=ts&setup=true"

import "./Zccx.vue?vue&type=style&index=0&id=95b34b98&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95b34b98"]])

export default __exports__